import { CBL_APIS } from "@/api_framework/api_config";
import { ICBLstatsBodyprops, ICBLStatsResponse } from "@/api_framework/api_modals/CBL";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setCBLStats } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export const useCBLStatsAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (filterParams: ICBLstatsBodyprops) => {
      dispatch(
        setLoading({
          key: "isPWLStatsFetchInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(CBL_APIS?.CBL_STATS_API?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<ICBLStatsResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setCBLStats({
                  data: res.data.data,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLStatsFetchInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setCBLStats({
                  data: null,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLStatsFetchInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isPWLStatsFetchInProgress",
                status: false,
              }),
            );
            dispatch(
              setCBLStats({
                data: null,
              }),
            );
            if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
              toast.error("Error while fetching stats list");
              dispatch(
                setCBLStats({
                  data: null,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLStatsFetchInProgress",
                  status: false,
                }),
              );
            }
          });
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
